import React, { useEffect, useState } from "react";
import { X, Copy } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const SEEN_KEY = "immuski_popup_seen_v1";

export default function PromoPopup() {
  const [popup, setPopup] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SEEN_KEY)) return;
    let mounted = true;
    api.get("/popups/active").then(({ data }) => {
      if (!mounted || !data) return;
      setPopup(data);
      const t = setTimeout(() => setShow(true), (data.show_after_seconds || 8) * 1000);
      return () => clearTimeout(t);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  const close = () => {
    setShow(false);
    sessionStorage.setItem(SEEN_KEY, "1");
  };

  if (!popup || !show) return null;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
  const imgSrc = popup.image_url
    ? (popup.image_url.startsWith("/api/") ? `${BACKEND_URL}${popup.image_url}` : popup.image_url)
    : null;
  return (
    <div className="fixed bottom-6 left-6 z-40 max-w-sm animate-fade-in-up" data-testid="promo-popup">
      <div className="relative bg-white border hairline shadow-2xl overflow-hidden">
        <button
          onClick={close}
          aria-label="Close"
          className="absolute top-2.5 right-2.5 z-20 w-8 h-8 rounded-full bg-ink-900 text-white hover:bg-black flex items-center justify-center shadow-[0_2px_10px_rgba(0,0,0,0.35)] ring-2 ring-white/90 focus:outline-none focus:ring-gold-500 transition-colors"
          data-testid="promo-close"
        >
          <X size={16} strokeWidth={2.5} />
        </button>
        {imgSrc && (
          <img src={imgSrc} alt="" className="w-full h-32 object-cover" data-testid="promo-image" />
        )}
        <div className="p-6">
          <div className="eyebrow">A little gift</div>
          <h3 className="mt-2 font-display text-2xl leading-tight text-ink-900">{popup.title}</h3>
          <p className="mt-3 text-sm text-ink-700 leading-relaxed">{popup.body}</p>
          {popup.coupon_code && (
            <div className="mt-5 flex items-center gap-2">
              <div className="flex-1 border hairline px-3 py-2 font-mono text-center tracking-[0.35em] text-ink-900 bg-white text-sm" data-testid="promo-code">
                {popup.coupon_code}
              </div>
              <button
                onClick={() => { navigator.clipboard.writeText(popup.coupon_code); toast.success("Code copied"); }}
                className="btn-primary-ink px-3 py-2 flex items-center gap-1 text-[10px] uppercase tracking-widest"
                data-testid="promo-copy"
              >
                <Copy size={12} /> Copy
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
